import {
  CashSessionConfirmAction,
  CashTransactionType,
  ManualCashTransactionType,
} from '@/@types/cash-management';
import { ConfirmModalColor } from '@/@types/confirm-modal';

export const formatCurrency = (value: number | null | undefined) => {
  if (value === null || value === undefined) return '-';

  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

export const transactionTypeLabel: Record<CashTransactionType, string> = {
  SALE: 'VENDA',
  PAY_IN: 'RECEBIMENTO',
  PAY_OUT: 'PAGAMENTO',
  CASH_IN: 'SUPRIMENTO',
  CASH_OUT: 'SANGRIA',
};

export const manualCashTransactionTypes: ManualCashTransactionType[] = [
  'PAY_IN',
  'PAY_OUT',
  'CASH_IN',
  'CASH_OUT',
];

export const cashSessionConfirmModalConfig: Record<
  CashSessionConfirmAction,
  ConfirmModalColor
> = {
  'start-reconciliation': 'warning',
  'cancel-manual-movement': 'error',
  revert: 'error',
  close: 'error',
};

export const cashSessionConfirmActionConfig: Record<
  CashSessionConfirmAction,
  { title: string; message: string; confirmButtonText: string }
> = {
  'start-reconciliation': {
    title: 'Iniciar conferência?',
    message: 'O caixa será movido para conferência.',
    confirmButtonText: 'Confirmar',
  },
  close: {
    title: 'Fechar caixa?',
    message: 'O caixa será fechado com as conferências salvas.',
    confirmButtonText: 'Confirmar',
  },
  revert: {
    title: 'Voltar status?',
    message: 'O caixa será revertido para o estado anterior.',
    confirmButtonText: 'Confirmar',
  },
  'cancel-manual-movement': {
    title: 'Cancelar movimentação?',
    message: 'A movimentação será cancelada.',
    confirmButtonText: 'Confirmar',
  },
};
